// LockValueCheckbox.js
import React from "react";

const LockValueCheckbox = ({ fieldName, value, onChange }) => {
  return (
    <div className="col-lg-4 gap-5 d-flex align-items-center">
      <div>
        <span>Lock value:</span>
      </div>
      <div className="form-check form-check-inline">
        <input
          type="radio"
          id={`${fieldName}Yes`}
          name={`${fieldName}`}
          value="yes"
          className="form-check-input"
          onChange={onChange}
          checked={value}
        />
        <label className="form-check-label" htmlFor={`${fieldName}Yes`}>
          Yes
        </label>
      </div>
      <div className="form-check form-check-inline">
        <input
          type="radio"
          id={`${fieldName}No`}
          name={`${fieldName}`}
          value="no"
          className="form-check-input"
          onChange={onChange}
          checked={!value}
        />
        <label className="form-check-label" htmlFor={`${fieldName}No`}>
          No
        </label>
      </div>
    </div>
  );
};

export default LockValueCheckbox;
